<template>
	<div>
		<Head title="Create User" />

		<Breadcrumbs
			href="/users"
			:parentLabel="__('Users')"
			:childLabel="__('Create')"
		/>

		<div class="w-full overflow-hidden rounded-md bg-white shadow">
			<form @submit.prevent="store">
				<div class="-mb-8 -mr-6 flex flex-wrap p-8">
					<TextInput
						v-model="form.name"
						class="w-full pb-8 pr-6 lg:w-1/2"
						:error="form.errors.name"
						:label="__('Name')"
					/>

					<TextInput
						v-model="form.role" :error="form.errors.role"
						class="w-full pb-8 pr-6 lg:w-1/2"
						:label="__('Role')"
					/>

					<TextInput
						v-model="form.phone"
						class="w-full pb-8 pr-6 lg:w-1/2"
						:error="form.errors.phone"
						:label="__('Phone')"
					/>

					<TextInput
						v-model="form.email"
						class="w-full pb-8 pr-6 lg:w-1/2"
						:error="form.errors.email"
						:label="__('Email')"
					/>

					<TextInput
						v-model="form.password"
						type="password"
						class="w-full pb-8 pr-6 lg:w-1/2"
						autocomplete="new-password"
						:error="form.errors.password"
						:label="__('Password')"
					/>

					<FileInput
						v-model="form.photo"
						type="file"
						class="w-full pb-8 pr-6 lg:w-1/2"
						accept="image/*"
						:error="form.errors.photo"
						:label="__('Photo (128x128 px, transparent png)')"
					/>
				</div>

				<div class="flex items-center justify-end border-t border-gray-100 bg-gray-50 px-8 py-4">
					<LoadingButton
						type="submit"
						class="btn-cta"
						:loading="form.processing"
					>
						Skapa användare
					</LoadingButton>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
	import { Head } 	  from '@inertiajs/inertia-vue3'
	import Layout 		  from '@/Shared/Layout'
	import FileInput 	  from '@/Shared/FileInput'
	import TextInput 	  from '@/Shared/TextInput'
	import LoadingButton  from '@/Shared/LoadingButton'
	import Breadcrumbs    from '@/Shared/Breadcrumbs'

	export default {
		components: {
			FileInput,
			Head,
			LoadingButton,
			TextInput,
			Breadcrumbs
		},
		layout: Layout,
		remember: 'form',
		data() {
			return {
				form: this.$inertia.form({
					name: '',
					role: '',
					phone: '',
					email: '',
					password: '',
					photo: null,
				})
			}
		},
		methods: {
			store() {
				this.form.post('/users')
			}
		}
	}
</script>
